import Page from "./Webzine";
import Detail from "./WebzineDetail.vue";

export default {
  Page,
  Detail
};
